import { c as _c } from "react/compiler-runtime";
import { zodResolver } from "@hookform/resolvers/zod";
import { useParams } from "next/navigation";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useTestimonyPost } from "@/app/(main)/(club)/mes-clubs/[id]/hooks/use-testimony-post";
import { CGUSection } from "@/app/(main)/(club)/mes-clubs/[id]/leads/components/send-lead/cgu-section/cgu-section";
import { MembersSection } from "@/app/(main)/(club)/mes-clubs/[id]/temoignages/components/members-section";
import { TestimonyText } from "@/app/(main)/(club)/mes-clubs/[id]/temoignages/components/testimony-text";
import { FormActions } from "@/app/(security)/inscription/components/form-actions";
import { useModalStore } from "@/stores/modal-store";
import { MemberRead, TestimonyRead } from "@/TS/Interfaces/global_interfaces";
import { useTestimonyPatch } from "../../hooks/use-testimony-patch";
import { sendTestimonySchema, SendTestimonyFormValues } from "../schemas/schema";
interface SendTestimonyProps {
  members: MemberRead[] | string;
  closeModal: () => void;
  testimony?: TestimonyRead;
  toBeUpdated?: boolean;
}
export const SendTestimony: React.FC<SendTestimonyProps> = t0 => {
  const $ = _c(62);
  const {
    members,
    testimony,
    closeModal,
    toBeUpdated
  } = t0;
  const {
    close
  } = useModalStore();
  const params = useParams();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = zodResolver(sendTestimonySchema);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== testimony?.witness?.id || $[2] !== toBeUpdated) {
    t2 = toBeUpdated ? testimony?.witness?.id?.toString() : "";
    $[1] = testimony?.witness?.id;
    $[2] = toBeUpdated;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = toBeUpdated ? testimony.description : "";
  const t4 = !!toBeUpdated;
  let t5;
  if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
    t5 = {
      resolver: t1,
      mode: "onSubmit",
      defaultValues: {
        witness: t2,
        description: t3,
        cgu: t4
      }
    };
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const methods = useForm(t5);
  const {
    handleSubmit,
    formState: t6
  } = methods;
  const {
    errors
  } = t6;
  const {
    mutate: postTestimony,
    isPending: isPosting,
    isSuccess: isPostingSuccess,
    isError: isPostingError
  } = useTestimonyPost(params.id as string);
  const {
    mutate: patchTestimony,
    isPending: isPatching,
    isSuccess: isPatchingSuccess,
    isError: isPatchingError
  } = useTestimonyPatch(params.id as string, testimony?.id);
  let t7;
  let t8;
  if ($[8] !== close || $[9] !== isPatchingSuccess || $[10] !== isPostingSuccess) {
    t7 = () => {
      if (isPostingSuccess || isPatchingSuccess) {
        const timer = setTimeout(() => {
          close();
        }, 3000);
        return () => clearTimeout(timer);
      }
    };
    t8 = [isPostingSuccess, isPatchingSuccess, close];
    $[8] = close;
    $[9] = isPatchingSuccess;
    $[10] = isPostingSuccess;
    $[11] = t7;
    $[12] = t8;
  } else {
    t7 = $[11];
    t8 = $[12];
  }
  useEffect(t7, t8);
  let t9;
  if ($[13] !== params.id || $[14] !== patchTestimony || $[15] !== postTestimony || $[16] !== toBeUpdated) {
    t9 = async data => {
      ;
      try {
        const apiData = {
          witness: `/members/${data.witness}`,
          description: data.description,
          consent: data.cgu,
          club: `/clubs/${params.id}`
        };
        if (toBeUpdated) {
          patchTestimony(apiData);
        } else {
          postTestimony(apiData);
        }
      } catch (t10) {
        const error = t10;
        console.error("Erreur lors de l'envoi du t\xE9moignage:", error);
      }
    };
    $[13] = params.id;
    $[14] = patchTestimony;
    $[15] = postTestimony;
    $[16] = toBeUpdated;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const onSubmit = t9;
  const t10 = testimony ? "Modifier" : "Ajouter";
  let t11;
  if ($[18] !== t10) {
    t11 = <h2 className="text-xl font-bold mb-6 text-center">{t10} un témoignage</h2>;
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== handleSubmit || $[21] !== onSubmit) {
    t12 = handleSubmit(onSubmit);
    $[20] = handleSubmit;
    $[21] = onSubmit;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      paddingBottom: "30px"
    };
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== members || $[25] !== methods || $[26] !== testimony || $[27] !== toBeUpdated) {
    t14 = <MembersSection methods={methods} members={members} toBeUpdated={toBeUpdated} testimony={testimony} />;
    $[24] = members;
    $[25] = methods;
    $[26] = testimony;
    $[27] = toBeUpdated;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  const t15 = errors.description?.message as string;
  let t16;
  if ($[29] !== methods || $[30] !== t15 || $[31] !== testimony || $[32] !== toBeUpdated) {
    t16 = <TestimonyText methods={methods} testimony={testimony} toBeUpdated={toBeUpdated} error={t15} />;
    $[29] = methods;
    $[30] = t15;
    $[31] = testimony;
    $[32] = toBeUpdated;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <CGUSection label={"Je certifie avoir obtenu le consentement du membre concern\xE9 concernant la publication de son t\xE9moignage sur le site Club d'Affaires"} />;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t14 || $[36] !== t16) {
    t18 = <div className="flex flex-col p-8 pb-0 rounded-lg bg-event bg-opacity-5"><div style={t13}>{t14}{t16}{t17}</div></div>;
    $[35] = t14;
    $[36] = t16;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== isPatchingSuccess || $[39] !== isPostingSuccess || $[40] !== toBeUpdated) {
    t19 = (isPostingSuccess || isPatchingSuccess) && <div className="text-center text-success2 font-medium py-2 bg-success rounded-lg animate-fadeIn">{toBeUpdated ? "T\xE9moignage modifi\xE9 avec succ\xE8s" : "T\xE9moignage ajout\xE9 avec succ\xE8s"}</div>;
    $[38] = isPatchingSuccess;
    $[39] = isPostingSuccess;
    $[40] = toBeUpdated;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== isPatchingError || $[43] !== isPostingError || $[44] !== toBeUpdated) {
    t20 = (isPostingError || isPatchingError) && <div className="text-center text-white font-medium py-2 bg-primary rounded-lg animate-fadeIn">Une erreur est survenue lors de{" "}{toBeUpdated ? "la modification" : "l'ajout"} du témoignage</div>;
    $[42] = isPatchingError;
    $[43] = isPostingError;
    $[44] = toBeUpdated;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = {
      border: "border-0"
    };
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  const t22 = isPosting || isPatching;
  let t23;
  if ($[47] !== closeModal || $[48] !== t22) {
    t23 = <FormActions style={t21} isPending={t22} closeModal={closeModal} />;
    $[47] = closeModal;
    $[48] = t22;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  let t24;
  if ($[50] !== t12 || $[51] !== t18 || $[52] !== t19 || $[53] !== t20 || $[54] !== t23) {
    t24 = <form onSubmit={t12} className="space-y-6">{t18}{t19}{t20}{t23}</form>;
    $[50] = t12;
    $[51] = t18;
    $[52] = t19;
    $[53] = t20;
    $[54] = t23;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] !== methods || $[57] !== t24) {
    t25 = <FormProvider {...methods}>{t24}</FormProvider>;
    $[56] = methods;
    $[57] = t24;
    $[58] = t25;
  } else {
    t25 = $[58];
  }
  let t26;
  if ($[59] !== t11 || $[60] !== t25) {
    t26 = <div>{t11}{t25}</div>;
    $[59] = t11;
    $[60] = t25;
    $[61] = t26;
  } else {
    t26 = $[61];
  }
  return t26;
};